module.exports = __webpack_public_path__ + "static/media/mailNew.c99a0650.png";